import script from "./AssetDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AssetDashboard.vue?vue&type=style&index=0&id=06132d78&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06132d78"]])

export default __exports__